Object.defineProperty(exports, '__esModule', {
  value: true
});
require('./_tslib-1246030c.js');
var formatting_currency = require('./formatting/currency.js');
require('date-fns');
require('date-fns/locale/en-GB');
require('./formatting/utils/dateFnsHelpers.js');
var formatting_date = require('./formatting/date.js');
var formatting_postcode = require('./formatting/postcode.js');
var formatting_string = require('./formatting/string.js');
var helpers_array_findById = require('./helpers/array/findById.js');
var helpers_colors_getAreaAvatarColor = require('./helpers/colors/getAreaAvatarColor.js');
require('./helpers/colors/constants.js');
require('@date-io/date-fns');
var helpers_date_customDateFnsUtils = require('./helpers/date/customDateFnsUtils.js');
var helpers_date_startOfWeekUK = require('./helpers/date/startOfWeekUK.js');
var helpers_date_getNextAndLastInvoiceRun = require('./helpers/date/getNextAndLastInvoiceRun.js');
var helpers_date_removeTimezoneOffset = require('./helpers/date/removeTimezoneOffset.js');
var helpers_forms_createFakeEvent = require('./helpers/forms/createFakeEvent.js');
var helpers_misc_fireOnce = require('./helpers/misc/fireOnce.js');
var helpers_misc_objectKeys = require('./helpers/misc/objectKeys.js');
var helpers_settings = require('./helpers/settings.js');
var helpers_string_getAvatarInitials = require('./helpers/string/getAvatarInitials.js');
var helpers_string_isWhitespaceOnly = require('./helpers/string/isWhitespaceOnly.js');
var regex_patterns = require('./regex/patterns.js');
require('validate.js');
require('lodash.get');
var regex_utils_regexValidator = require('./regex/utils/regexValidator.js');
require('./regex/regexTester.js');
var regex_validators = require('./regex/validators.js');
exports.convertPenniesToPounds = formatting_currency.convertPenniesToPounds;
exports.formatCurrency = formatting_currency.formatCurrency;
exports.formatDate = formatting_date.formatDate;
exports.formatDateLong = formatting_date.formatDateLong;
exports.formatDateShort = formatting_date.formatDateShort;
exports.formatDistance = formatting_date.formatDistance;
exports.formatTime = formatting_date.formatTime;
exports.formatPostcode = formatting_postcode.formatPostcode;
exports.camelCaseToSpacedPascalCase = formatting_string.camelCaseToSpacedPascalCase;
exports.getInitials = formatting_string.getInitials;
exports.slashSeparatedToHyphenSeparated = formatting_string.slashSeparatedToHyphenSeparated;
exports.upperCaseFirstCharacter = formatting_string.upperCaseFirstCharacter;
exports.findById = helpers_array_findById.findById;
exports.getAreaAvatarColor = helpers_colors_getAreaAvatarColor.getAreaAvatarColor;
exports.stringToColour = helpers_colors_getAreaAvatarColor.stringToColour;
exports.CustomDateFnsUtils = helpers_date_customDateFnsUtils.CustomDateFnsUtils;
exports.startOfWeekUK = helpers_date_startOfWeekUK.startOfWeekUK;
exports.INVOICE_RUN_DAY = helpers_date_getNextAndLastInvoiceRun.INVOICE_RUN_DAY;
exports.INVOICE_RUN_HOUR = helpers_date_getNextAndLastInvoiceRun.INVOICE_RUN_HOUR;
exports.getNextAndLastInvoiceRun = helpers_date_getNextAndLastInvoiceRun.getNextAndLastInvoiceRun;
exports.removeTimezoneOffset = helpers_date_removeTimezoneOffset.removeTimezoneOffset;
exports.createFakeEvent = helpers_forms_createFakeEvent.createFakeEvent;
exports.fireOnce = helpers_misc_fireOnce.fireOnce;
exports.reset = helpers_misc_fireOnce.reset;
exports.objectKeys = helpers_misc_objectKeys.objectKeys;
exports.restoreSettings = helpers_settings.restoreSettings;
exports.storeSettings = helpers_settings.storeSettings;
exports.getAvatarInitials = helpers_string_getAvatarInitials.getAvatarInitials;
exports.isWhitespaceOnly = helpers_string_isWhitespaceOnly.isWhitespaceOnly;
exports.ACCOUNT_NUMBER_REGEX = regex_patterns.ACCOUNT_NUMBER_REGEX;
exports.DRIVING_LICENCE_REGEX = regex_patterns.DRIVING_LICENCE_REGEX;
exports.EMAIL_ADDRESS_REGEX = regex_patterns.EMAIL_ADDRESS_REGEX;
exports.ISO_DATE_REGEX = regex_patterns.ISO_DATE_REGEX;
exports.POSTCODE_REGEX = regex_patterns.POSTCODE_REGEX;
exports.SORTCODE_REGEX = regex_patterns.SORTCODE_REGEX;
exports.VEHICLE_REGISTRATION_REGEX = regex_patterns.VEHICLE_REGISTRATION_REGEX;
exports.regexTester = regex_utils_regexValidator.test;
exports.isValidAccountNumber = regex_validators.isValidAccountNumber;
exports.isValidDrivingLicenceNumber = regex_validators.isValidDrivingLicenceNumber;
exports.isValidEmailAddress = regex_validators.isValidEmailAddress;
exports.isValidPostCode = regex_validators.isValidPostCode;
exports.isValidSortcode = regex_validators.isValidSortcode;
exports.isValidVehicleRegistration = regex_validators.isValidVehicleRegistration;